import { Component, Input, ViewChild, ElementRef } from '@angular/core';
import { AnimationService, AnimationBuilder } from 'css-animator';
@Component({
  selector: 'modal-home-screen',
  templateUrl: 'modal-home-screen.html'
})
export class ModalHomeScreenComponent {

  @Input() configColor: any;
  @Input() localstorageName: string = 'viewOnBoardingHome';
  @ViewChild('modalContainer') modalContainer: ElementRef;

  public showModal: boolean = false;
  private animatorModal: AnimationBuilder;
  public storageValue;

  constructor(
    public animationService: AnimationService
  ) { }

  ngOnInit(): void {
    let valueView = window.localStorage.getItem(this.localstorageName);
    if (valueView !== "true") {
      this.showModal = true;
      setTimeout(() => {
        this.animatorModal = this.animationService.builder();
        // this.animatorModal.setType('fadeIn').show(this.modalContainer.nativeElement);
      }, 800);
    }
  }

  closeModal() {
    this.animatorModal.setType('fadeOut').hide(this.modalContainer.nativeElement);
    window.localStorage.setItem(this.localstorageName, "true");
    setTimeout(() => {
      this.showModal = false;
    }, 600);
  }

  // ngOnInit(): void {
  //   this.animatorModal = this.animationService.builder();
  //   // this.showOnboarding();
  // }

  // showOnboarding() {
  //   let valueView = window.localStorage.getItem('viewOnBoarding');
  //   if (valueView == "true") {
  //     this.showModal = false;
  //   } else {
  //     this.storageValue = window.localStorage.setItem('viewOnBoarding', 'true');
  //     this.showModal = false;
  //   }
  // }

  // closeModal() {
  //   this.showModal = false;
  // }

  // ngAfterViewInit() {
  //   if (this.modalContainer) {
  //     this.animatorModal.setType('fadeIn').show(this.modalContainer.nativeElement);
  //   }
  // }
}



// WEBPACK FOOTER //
// ./src/components/modal-home-screen/modal-home-screen.ts